import { ReactComponent as ShareButton } from '../../assets/icon/Share2.svg';

export default function SharePrint({ showShareModal, setShowShareModal }) {
	return (
		<div className='flex justify-end w-full px-4 md:w-full md:px-8 '>
			<ShareButton onClick={() => setShowShareModal(!showShareModal)} />
		</div>
	);
}
